import { render } from "./App.vue?vue&type=template&id=15f7426a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=15f7426a&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__